import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Container } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import NavLink from '../../UI/Links/NavLink';
import RoutePath from '../../../constants/route-path';

export const RegisterComplete = () => {
    return (
        <Container maxW="xl">
            <Alert
                status="success"
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                height="200px"
            >
                <AlertIcon boxSize="40px" mr={0} />
                <AlertTitle mt={4} mb={1} fontSize="lg">
                    <FormattedMessage id="registration-completed" />
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                    <FormattedMessage id="registration-completed-message" />
                </AlertDescription>
                <Box pt={4}>
                    <NavLink href={RoutePath.Home} variant="boldedBlue" passHref>
                        <FormattedMessage id="go-to-homepage" />
                    </NavLink>
                </Box>
            </Alert>
        </Container>
    );
};
